// 2P AI — icona Material Symbols Rounded (font self-hostato). Il nome è la legatura del simbolo.
export function Icon({ name, className }: { name: string; className?: string }) {
  return (
    <span className={className ? `ms ${className}` : 'ms'} aria-hidden="true">{name}</span>
  );
}
